"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unreachable = exports.assert = void 0;
const errorBase_1 = require("../errors/errorBase");
function assert(cond, errMsg) {
    const msg = errMsg ? `: ${errMsg}` : '';
    if (!cond)
        throw new errorBase_1.ErrorBase(`Assertion failed${msg}`);
}
exports.assert = assert;
function unreachable(_val) {
    assert(false, 'Unreachable code hit');
}
exports.unreachable = unreachable;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXJ0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2Fzc2VydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBNkM7QUFFN0MsU0FBZ0IsTUFBTSxDQUFDLElBQWEsRUFBRSxNQUFjO0lBQ2xELE1BQU0sR0FBRyxHQUFHLE1BQU0sQ0FBQyxDQUFDLENBQUMsS0FBSyxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFBO0lBQ3ZDLElBQUksQ0FBQyxJQUFJO1FBQUUsTUFBTSxJQUFJLHFCQUFTLENBQUMsbUJBQW1CLEdBQUcsRUFBRSxDQUFDLENBQUE7QUFDMUQsQ0FBQztBQUhELHdCQUdDO0FBRUQsU0FBZ0IsV0FBVyxDQUFDLElBQVc7SUFDckMsTUFBTSxDQUFDLEtBQUssRUFBRSxzQkFBc0IsQ0FBQyxDQUFBO0FBQ3ZDLENBQUM7QUFGRCxrQ0FFQyJ9